module.exports = __webpack_public_path__ + "static/img/hangyeli2.3a27468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/hangyeli2.png
// module id = /1jr
// module chunks = 5